export const uploadEditInfo = {
    editExcludeFields: []
}